import { createSelector } from 'reselect';
import { PASSAGE } from '../constants/assessmentItemType';

export const getIsDazeDataFetched = (state) => state.isDataFetched;

export const getDazeParagraphs = (state, pageType = PASSAGE) => state[pageType].paragraphs;

export const getDazeQuestionItems = (state, pageType = PASSAGE) => state[pageType].items;

export const getDazeReadyForNextScript = (state) => state.isReadyScriptPlayed;

export const getDazeTitle = (state, pageType = PASSAGE) => state[pageType].title;

export const getDazeCorrectResponse = (state, pageType, questionId) => {
    const questions = getDazeQuestionItems(state, pageType);
    const questionById = questions.find((question) => question.id === questionId);
    return questionById && questionById.correctResponse;
};

export const getIsDazeFirstAttemptMade = (state) => state.isFirstAttemptMade;

export const getLastDazeQuestion = createSelector(
    getDazeQuestionItems,
    (questions) => questions[questions.length - 1],
);

export const getDazeSelectedResponses = (state) => state.selectedResponses;

export const getDazeFormId = (state) => state.formId;

export const getDazeScreenMode = (state) => state.screenMode;
